export const RT_DELIVERY_PATH = {
  UPDATE_HANDOFF_DETAIL:
    'api/rs-aliados-gateway/orders/partner/status/orders/bags',
  GET_HANDOFF_DETAIL:
    '/api/rs-aliados-gateway/orders/partner/status/orders/bags/confirmation/:orderId',
} as const;
